var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConejito({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 108",
    width: 50,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #359046 } \n\t\t.shp1 { fill: #297f43 } \n\t\t.shp2 { fill: #4e9847 } \n\t\t.shp3 { fill: #5ea34d } \n\t\t.shp4 { fill: #83b466 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_177_",
    className: "shp0",
    d: "M87.9,43.7l1.8,-8l-13.3,-12.2l-21.9,-18.1l-15.7,-3.8l-13.8,2.9l8.4,0.3c-4.7,-0.1 -8.3,-0.2 -8.3,-0.2l0.1,1.5l25.6,12.1l-14.9,-2.5l-28.3,11l0.9,1.9c0,0 48.1,2.8 49.8,3.3v0l-0.5,8.9l-38.7,18.6l-0.1,0.8l-4,-6.5c-0.1,0.1 -1,0.9 -2.3,2l2.3,-2l-7.7,3.8l0.2,2.7c-1.5,1.3 -2.6,2.2 -2.6,2.2l12.6,7.8l0.2,-1.2l-0.2,1.3l-12.6,-7.9l-1,8.6l13.1,3.1l-2.3,15.7l15.5,15.1l34.1,0.3l1.1,-1.4l-15.1,-10l17.2,-0.8l1,-0.9l-16.7,-7.7l6.3,-6l11.4,9.6l0.9,-0.8l-4,-14.7l7.5,3.2l0.9,-0.7l-5.6,-14.5l4.6,-11z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "shp1",
    d: "M89.7,35.7l-15.9,13.8l14.1,-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "shp1",
    d: "M67.5,93l1,-0.9l-16.8,-7.7l-10.2,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "shp1",
    d: "M73.9,75.7l0.9,-0.7l-5.7,-14.7l-4.9,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "shp1",
    d: "M54.5,5.4l21.9,18.1l-25.4,-5.2l-25.8,-12.2l-0.1,-1.5c-0.1,-0.1 29.8,0.7 29.4,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "shp1",
    d: "M7.3,57.5l0.2,2.7l7.5,-6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "shp0",
    d: "M57.8,40.8l0.9,37.5l3.8,-1.7l11.3,-27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "shp0",
    d: "M30.2,104.9l27.9,-26.5l-43.4,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "shp0",
    d: "M73.9,32.6l-0.1,16.9l15.9,-13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "shp0",
    d: "M7.6,26.7l0.9,1.9c0,0 50.3,2.9 49.9,3.3c-0.4,0.4 14.9,-9.9 14.9,-9.9l-37.4,-6.3c0,0 -13.2,9.2 -13.2,9.5c-0.1,0.2 -15.1,1.5 -15.1,1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "shp2",
    d: "M15,53.7c-0.2,0.2 -10.1,8.7 -10.1,8.7l12.6,7.8l1.7,-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "shp2",
    d: "M57.8,40.8l-43.1,49l43.4,-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "shp2",
    d: "M57.8,40.8l16,8.7l0.1,-16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "shp2",
    d: "M76.4,23.5l-2.5,9.1l15.8,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "shp2",
    d: "M7.6,26.7l15.4,-1.2l12.9,-9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "shp3",
    d: "M3.9,71l13.1,3.1l0.6,-3.8l-12.7,-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "shp3",
    d: "M19.1,59.4l-4.4,30.4l43.1,-49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "shp3",
    d: "M64.3,105.2l1.1,-1.4l-20.1,-13.3l-15.1,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "shp3",
    d: "M70.4,87.2l-12.6,-46.4l0.3,37.6l11.4,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "shp3",
    d: "M73.2,22l-14.9,9.9l15.6,0.7l2.5,-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "shp3",
    d: "M38.8,1.6l-13.8,2.9l29.5,0.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "shp4",
    d: "M57.8,40.8l16.1,-8.2l-15.6,-0.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConejito);
export default __webpack_public_path__ + "static/media/conejito.cc60b10b3ab53bbef5b31622c5e36d35.svg";
export { ForwardRef as ReactComponent };